import React, { Component } from 'react'
import { CardContainer } from './style';
import ExchangesCard from './ExchangesCard/ExchangesCard';
import RecurringExchangesCard from './RecurringExchangesCard/RecurringExchangesCard';

export default class RenderCard extends Component {
    renderElement = (props) => {
        switch (props.component) {
            case 'ExchangesCard':
                return <ExchangesCard {...props} />
            case 'RecurringExchangesCard':
                return <RecurringExchangesCard {...props} />  
            default:
                break;
        }
    }
    render() {
        const { index } = this.props;
        return (
            <div>
                <CardContainer index={index % 2}>
                    {this.renderElement({...this.props})}
                </CardContainer>
            </div>
        )
    }
}
